export default function /* @ngInject */ PaymentProfileResource($resource, config) {
    let urlBase = `${config.accountsApiUrl}/api/v1/stripe`;
    let actions = {
        getProfile: {
            url: `${urlBase}/payment-profile`,
            method: 'GET'
        },
        transactions: {
            url: `${urlBase}/transactions`,
            method: 'GET',
            cached: true,
            isArray: true
        }
    };

    return $resource(urlBase, {}, actions);
}



// WEBPACK FOOTER //
// ./payments/resources/payment-profile.js